<template>
    <div class="block block-methods" v-if="currentProduct">
        <div class="method-bg_img" :key="'bg' + activeSlideProd">
            <img v-if="currentProduct.bg_img_bottom" class="bg_img bg_img_bottom"
                :src="currentProduct.bg_img_bottom" alt="">
            <img v-if="currentProduct.bg_img_left" class="bg_img bg_img_left"
                :src="currentProduct.bg_img_left" alt="">
            <img v-if="currentProduct.bg_img_top_big" class="bg_img bg_img_top_big"
                :src="currentProduct.bg_img_top_big" alt="">
            <img v-if="currentProduct.bg_img_top_small" class="bg_img bg_img_top_small"
                :src="currentProduct.bg_img_top_small" alt="">
        </div>
        <div class="content-box method-wr" :key="activeSlideProd">
            <div>
                <h2 class="title" :class="{ 'new-con': true }" v-html="currentProduct.title_1"></h2>
                <div class="title-bottom">
                    <img v-for="item in currentProduct.title_imgs" :key="item" :src="item"
                        alt="">
                    <h2 class="title" v-html="currentProduct.title_2"></h2>
                </div>
                <p class="description descr2" v-html="currentProduct.description"></p>
            </div>
            <div class="method">
                <div class="method__title" v-html="cookings[activeSlideProd].method_title"></div>
                <!-- Способ приготовления -->
                <div class="method__line">
                    <!-- Шаги -->
                    <div v-for="(item, index) in cookings[activeSlideProd].steps" :key="'step' + index"
                        class="method__box">
                        <div class="method__img">
                            <span class="method__number-box"><span class="method__number">{{ index + 1 }}</span></span>
                            <img :src="item.image" alt="">
                        </div>
                        <div class="method__text" v-html="item.text"></div>
                    </div>
                </div>
            </div>
            <div class="line-block">
                <router-link tag="button" v-on:click.native="goToPage()" :to="`/${langContent}/recipes`"
                    class="button button-next-slide button_brown" v-html="currentProduct.btn_next"></router-link>
                <router-link tag="button" v-on:click.native="goToPage()" :to="`/${langContent}/recipes`"
                    class="button button-down button_white">
                    <i class="far fa-angle-down"></i>
                </router-link>
            </div>
        </div>
        <div class="prod-slider">
            <div v-if="cookings.length > 1" class="prod-slider__button">
                <button @click="productСarouselPrev()" class="slider-button" id="prod-slider-button-prev"><i
                        class="far fa-angle-left"></i></button>
                <button @click="productСarouselNext()" class="slider-button" id="prod-slider-button-next"><i
                        class="far fa-angle-right"></i></button>
            </div>

            <div class="prod-slider__content" :class="{ 'single-slide': cookings.length === 1 }" v-if="cookings.length">
                <div class="prod-slider-slide" v-for="(img, index) in cookings" :key="'img' + index"
                    :ref="'slide' + index"
                    :class="{ 'active': index === activeSlideProd, slidePrev: isSlidePrev && index === activeSlideProd, scaleActive: img.isScaleActive, }">
                    <img :src="img.image" class="prod-slider__img">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP, Routes } from '../API'
export default {
    props: {
        langContent: { type: String, default: 'ru' },
    },
    data() {
        return {
            srollPageVal: 'slide-fadeTop',
            removeScrollButton: true,
            slideNext: false,
            slidePrev: false,
            slide: null,
            slideFlag: true,
            cookings: [],
            currentProduct: null,
            activeSlideProd: 0,
            slideActive: false,
            isScaleActive: false,
            isSlidePrev: false,
            pageTitle: null,
            steps: [],
            cookingСhocolate: [],
            cookingStrawberry: [],
            nextButton: null,
            prodYellow: null,
            prodCocoa: null,
            isAnimating: false, // Флаг для блокировки анимации во время переключения
        }
    },
    methods: {
        goToPage() {
            this.$emit('scrollPage', this.srollPageVal)
        },

        getPrevIndex() {
            if (this.cookings.length === 0) return 0;
            return this.activeSlideProd === 0 ? this.cookings.length - 1 : this.activeSlideProd - 1;
        },

        getNextIndex() {
            if (this.cookings.length === 0) return 0;
            return this.activeSlideProd === this.cookings.length - 1 ? 0 : this.activeSlideProd + 1;
        },

        animateCurrentSlideBeforeChange() {
            const currentIndex = this.activeSlideProd;

            // Запускаем анимацию уменьшения текущего слайда
            this.cookings[currentIndex].isScaleActive = true;
            this.$forceUpdate();

            // Убираем класс анимации через время, равное длительности анимации
            setTimeout(() => {
                this.cookings[currentIndex].isScaleActive = false;
                this.$forceUpdate();
            }, 850); // Длительность анимации
        },

        productСarouselPrev() {
            // Защита от множественных кликов во время анимации
            if (this.cookings.length <= 1 || this.isAnimating) return;

            this.isAnimating = true;

            // Анимируем текущий слайд (он будет уменьшаться)
            this.animateCurrentSlideBeforeChange();

            // Меняем слайд после небольшой задержки, чтобы увидеть анимацию
            setTimeout(() => {
                const newIndex = this.getPrevIndex();
                this.activeSlideProd = newIndex;
                this.currentProduct = this.cookings[this.activeSlideProd];
                this.isSlidePrev = true;

                // Сбрасываем флаг анимации
                setTimeout(() => {
                    this.isAnimating = false;
                }, 100);
            }, 100); // Задержка должна быть меньше длительности анимации
        },

        productСarouselNext() {
            // Защита от множественных кликов во время анимации
            if (this.cookings.length <= 1 || this.isAnimating) return;

            this.isAnimating = true;

            // Анимируем текущий слайд (он будет уменьшаться)
            this.animateCurrentSlideBeforeChange();

            // Меняем слайд после небольшой задержки, чтобы увидеть анимацию
            setTimeout(() => {
                const newIndex = this.getNextIndex();
                this.activeSlideProd = newIndex;
                this.currentProduct = this.cookings[this.activeSlideProd];
                this.isSlidePrev = true;

                // Сбрасываем флаг анимации
                setTimeout(() => {
                    this.isAnimating = false;
                }, 100);
            }, 100); // Задержка должна быть меньше длительности анимации
        },

        getContent() {
            HTTP.get(Routes.cooking)
                .then(response => {
                    if (response.data.err === 0) {
                        this.cookings = response.data.cooking;
                        // Если нет продуктов, выходим
                        if (!this.cookings.length) return;

                        // Убеждаемся, что activeSlideProd не выходит за пределы массива
                        if (this.activeSlideProd >= this.cookings.length) {
                            this.activeSlideProd = 0;
                        }

                        this.currentProduct = this.cookings[this.activeSlideProd];
                        this.cookings.forEach(el => el.isScaleActive = false);
                        this.slide = document.getElementsByClassName('prod-slider-slide');

                        this.nextButton = response.data.cooking[0].btn_next;
                        setTimeout(() => {
                            this.$emit('buttonNextScroll', this.nextButton);
                        }, 0);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },

        // Метод для обновления размеров слайдера при одном продукте
        updateSliderForSingleSlide() {
            if (this.cookings.length === 1 && this.$nextTick) {
                this.$nextTick(() => {
                    const sliderContent = document.querySelector('.prod-slider__content');
                    if (sliderContent) {
                        sliderContent.style.justifyContent = 'center';
                    }
                });
            }
        }
    },

    mounted() {
        this.getContent();
    },

    updated() {
        this.updateSliderForSingleSlide();
    },

    beforeCreate() {
        this.removeScrollButton = true;
        this.$emit('removeButtonScrollFooter', this.removeScrollButton);
    },
}
</script>

<style scoped>
/* Добавьте эти стили для корректного отображения одного слайда */
.prod-slider__content.single-slide {
    display: flex;
    justify-content: center;
    align-items: center;
}

.prod-slider__content.single-slide .prod-slider-slide {
    margin: 0 auto;
}

/* Для двух слайдов можно добавить особые стили при необходимости */
/* .prod-slider__content:not(.single-slide) {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: hidden;
} */
</style>